import { render, staticRenderFns } from "./ProductsCarousel.vue?vue&type=template&id=578e95c0&scoped=true&"
import script from "./ProductsCarousel.vue?vue&type=script&lang=js&"
export * from "./ProductsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCarousel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ProductsCarousel.vue?vue&type=style&index=1&id=578e95c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578e95c0",
  null
  
)

export default component.exports